module.exports = __webpack_public_path__ + "static/media/0022_LES_MURS_BIBOND_IMPRESSION_BRIQUE.59ba6b2b.webp";